import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AuthShell, inputCls } from "@/pages/Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <AuthShell title="Pozabljeno geslo" subtitle="Vpišite e-poštni naslov računa. Poslali vam bomo povezavo za nastavitev novega gesla.">
      {sent ? (
        <p className="text-sm" data-testid="forgot-sent">Če račun s tem naslovom obstaja, smo vam poslali povezavo. Velja 1 uro.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input className={inputCls} type="email" required placeholder="E-poštni naslov" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          <button className="btn-dark w-full h-12" data-testid="forgot-submit-button">Pošlji povezavo</button>
        </form>
      )}
      <p className="text-sm text-[#6C6560] mt-6"><Link to="/prijava" className="underline text-[#B39264]">Nazaj na prijavo</Link></p>
    </AuthShell>
  );
}

export function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Gesli se ne ujemata.");
    try { await api.post("/auth/reset-password", { token, password: pw }); toast.success("Geslo je spremenjeno. Prijavite se."); nav("/prijava"); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <AuthShell title="Novo geslo" subtitle="Vpišite novo geslo (vsaj 8 znakov).">
      <form onSubmit={submit} className="space-y-4">
        <input className={inputCls} type="password" minLength={8} required placeholder="Novo geslo" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" />
        <input className={inputCls} type="password" minLength={8} required placeholder="Ponovite geslo" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm" />
        <button className="btn-dark w-full h-12" data-testid="reset-submit-button">Shrani novo geslo</button>
      </form>
    </AuthShell>
  );
}
